import React from 'react';

interface PagePanelProps {
    title: string;
    children?: React.ReactNode;
    className?: string;
    /** Minimum width before wrapping. Defaults to 280px. */
    minWidth?: number;
    /** Extra inline styles merged after the default sizing styles. */
    style?: React.CSSProperties;
    /** Optional actions rendered in the top-right corner of the panel header. */
    actions?: React.ReactNode;
}

export default function PagePanel({ title, children, className = '', minWidth = 280, style, actions }: PagePanelProps) {
    return (
        <div
            className={`page-panel ${className}`.trim()}
            style={{ flexBasis: minWidth, minWidth, ...style }}
        >
            <span className='page-panel-title'>{title}</span>
            {actions && <div className='page-panel-actions'>{actions}</div>}
            <div className='page-panel-body'>{children}</div>
        </div>
    );
}
